import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Estimates from "./pages/Estimates";
import Gallery from "./pages/Gallery";
import Coverage from "./pages/Coverage";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminSettings from "./pages/AdminSettings";
import AdminPricing from "./pages/AdminPricing";
import AdminServices from "./pages/AdminServices";
import AdminGallery from "./pages/AdminGallery";
import AdminTestimonials from "./pages/AdminTestimonials";
import AdminCoverageAreas from "./pages/AdminCoverageAreas";
import AdminFAQs from "./pages/AdminFAQs";
import AdminContactInfo from "./pages/AdminContactInfo";
import AdminHomeContent from "./pages/AdminHomeContent";
import AdminSubmissions from "./pages/AdminSubmissions";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster />
        <Routes>
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/settings" element={<AdminSettings />} />
          <Route path="/admin/pricing" element={<AdminPricing />} />
          <Route path="/admin/services" element={<AdminServices />} />
          <Route path="/admin/gallery" element={<AdminGallery />} />
          <Route path="/admin/testimonials" element={<AdminTestimonials />} />
          <Route path="/admin/coverage-areas" element={<AdminCoverageAreas />} />
          <Route path="/admin/faqs" element={<AdminFAQs />} />
          <Route path="/admin/contact-info" element={<AdminContactInfo />} />
          <Route path="/admin/home-content" element={<AdminHomeContent />} />
          <Route path="/admin/submissions" element={<AdminSubmissions />} />
          
          {/* Public Routes */}
          <Route path="/*" element={
            <>
              <Header />
              <main>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/services" element={<Services />} />
                  <Route path="/estimates" element={<Estimates />} />
                  <Route path="/gallery" element={<Gallery />} />
                  <Route path="/coverage" element={<Coverage />} />
                  <Route path="/contact" element={<Contact />} />
                </Routes>
              </main>
              <Footer />
            </>
          } />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
